<template>
  <footer class="mx-auto inline-block">
    <div class="text-sm text-center mt-6">
      View source code at
      <a
        href="https://github.com/devcoderoad/gerimis-app"
        rel="nofollow"
        class="font-bold underline hover:no-underline"
        >GitHub</a
      >
      <div>
        Icons are from
        <a
          href="https://phosphoricons.com/"
          rel="nofollow"
          class="font-bold underline hover:no-underline"
          >Phosphor Icons
        </a>
      </div>
      <div>
        Read about
        <a
          href="https://medium.com/javascript-in-plain-english/how-to-build-vuejs-geo-location-weather-application-f65f5cc2fa4f"
          target="_blank"
          class="font-bold underline hover:no-underline"
          title="Vue.js Geo-location Weather Application on Medium"
          >this</a
        >
      </div>
    </div>
  </footer>
</template>
<script>
export default {
  name: 'Footer'
}
</script>
